import script from "./FundList.vue?vue&type=script&lang=ts&setup=true"
export * from "./FundList.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__